import { ReactElement } from 'react';
import { toast } from 'react-toastify';
import { Button, ButtonGroup, openModal } from '@ff-it/ui';
import { DownloadButton } from 'components';
import { typeIconMap } from 'components/Icon';
import { CreateBlockDialog } from 'modules/campaign/block/dialogs';
import type { BlockDetails } from 'modules/campaign/block/types';
import { useAgenecyTypeOptions } from 'modules/core/useEnabledTypeOptions';
import type { CampaignDetails } from '../types';

interface ToolbarProps {
  addBlock: (block: BlockDetails) => void;
  campaign: CampaignDetails;
}

export function Toolbar({ campaign, addBlock }: ToolbarProps): ReactElement {
  const activityTypeOptions = useAgenecyTypeOptions();
  return (
    <div className="d-flex">
      <ButtonGroup testId="toolbar-add-controls">
        {activityTypeOptions.map(({ label, value: type }) => (
          <Button
            size="sm"
            icon={typeIconMap[type]}
            key={type}
            variant="secondary"
            testId={`add-block-${type}`}
            onClick={() =>
              openModal<BlockDetails>((props) => <CreateBlockDialog {...props} type={type} campaign={campaign} />, {
                className: 'right',
                canDismiss: false,
              }).then((res) => {
                if (res) {
                  addBlock(res);
                  toast.success('Block has been added.', { toastId: 'add-block-toast' });
                }
              })
            }
          >
            {label}
          </Button>
        ))}
      </ButtonGroup>

      <ButtonGroup ml="auto" data-testid="toolbar-export-controls">
        <DownloadButton
          url={`campaign/campaigns/${campaign.id}/export_blocks/`}
          icon="file-excel"
          variant="ghost"
          title="Export blocks"
        >
          Export blocks
        </DownloadButton>
        <DownloadButton
          url={`campaign/campaigns/${campaign.id}/export_rows/`}
          icon="file-excel"
          variant="ghost"
          title="Export rows"
        >
          Export rows
        </DownloadButton>
      </ButtonGroup>
    </div>
  );
}
